import MapView from "@arcgis/core/views/MapView";
import Zoom from "@arcgis/core/widgets/Zoom";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { view } from "../../../../../utils/API";
import {
  StyledMapContainer,
  StyledMapFocus,
  StyledTitle,
  StyledTitleContainer,
  StyledViewContainer,
} from "../NotificationMenu-styled";

const NotificationMap = ({ setCurrentView }) => {
  const mapRef = useRef(null);
  const { t } = useTranslation("common");

  useEffect(() => {
    let currView;
    if (!view || !mapRef.current) return;

    if (mapRef.current) {
      currView = new MapView({
        container: mapRef.current,
        map: view.map,
        center: view.center,
        zoom: view.zoom,
        ui: {
          components: [],
        },
        constraints: view.constraints,
        popup: null,
      });

      currView.when(() => {
        setCurrentView(currView);
        setTimeout(() => {
          const zoom = new Zoom({
            view: currView,
          });

          currView.ui.add(zoom, {
            position: "bottom-right",
          });
        }, 250);
      });
    }
  }, []);

  return (
    <StyledMapContainer>
      <StyledTitleContainer>
        <StyledTitle>
          {t("screen.widget.Editor.notifications.map.title")}
        </StyledTitle>
      </StyledTitleContainer>

      <StyledViewContainer>
        <div ref={mapRef} />
        <StyledMapFocus>
          <div />
        </StyledMapFocus>
      </StyledViewContainer>
    </StyledMapContainer>
  );
};

export default NotificationMap;
